import List from 'containers/Languages/List';
import Edit from 'containers/Languages/Edit';
import Create from 'containers/Languages/Create';
import Show from 'containers/Languages/Show';

export default { List, Edit, Create, Show };
